module.exports = __webpack_public_path__ + "static/img/LUCAS-CAMPOREALE.246793b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LUCAS-CAMPOREALE.jpg
// module id = bKba
// module chunks = 0